import { api } from '../api';

export type HubspotSyncEstado = 'corriendo' | 'terminado' | 'error';

export interface HubspotSyncFallido {
  legajo: string;
  motivo: string;
}

export interface HubspotSyncResumen {
  totalAsociados: number;
  procesados: number;
  totalLegajos: number;
  legajosExitosos: number;
  legajosFallidos: number;
}

export interface HubspotSyncJob {
  _id: string;
  padronId: string;
  estado: HubspotSyncEstado;
  startedAt: string;
  finishedAt?: string;
  totalAsociados: number;
  procesados: number;
  totalLegajos: number;
  legajosExitosos: number;
  legajosFallidos: number;
  fallidos: HubspotSyncFallido[];
  resumen?: HubspotSyncResumen;
  error?: string;
  disparadoPor?: string;
  batchSize: number;
}

export async function dispararHubspotSync(padronId: string): Promise<HubspotSyncJob> {
  const { data } = await api.post<HubspotSyncJob>(
    `/admin/hubspot-sync/padrones/${padronId}/disparar`,
  );
  return data;
}

export async function getHubspotSyncLatestJob(padronId: string): Promise<HubspotSyncJob | null> {
  try {
    const { data } = await api.get<HubspotSyncJob>(
      `/admin/hubspot-sync/padrones/${padronId}/jobs/latest`,
    );
    return data;
  } catch (err) {
    const e = err as { response?: { status?: number } };
    // 404 = nunca corrió un job para este padrón; lo tratamos como "no hay job"
    // sin propagar el error al UI.
    if (e.response?.status === 404) return null;
    throw err;
  }
}

export interface HubspotSyncCobertura {
  total: number;
  conHubspotId: number;
  porcentaje: number;
}

/**
 * Cobertura de sync HubSpot del padrón: cuántos titulares ya tienen contacto
 * creado en HubSpot (= `hubspotId` guardado en Mongo) sobre el total. Reemplaza
 * al botón de disparar como info principal del card de admin.
 */
export async function getHubspotSyncCobertura(padronId: string): Promise<HubspotSyncCobertura> {
  const { data } = await api.get<HubspotSyncCobertura>(
    `/admin/hubspot-sync/padrones/${padronId}/cobertura`,
  );
  return data;
}

export async function reintentarHubspotSync(padronId: string): Promise<HubspotSyncJob> {
  const { data } = await api.post<HubspotSyncJob>(
    `/admin/hubspot-sync/padrones/${padronId}/reintentar`,
  );
  return data;
}
